/** Maximale Länge des Tippnamens (display_name), siehe Backend RegisterAction/UpdateProfileAction. */
export const DISPLAY_NAME_MAX_LENGTH = 16;

/** Ab dieser Länge wird der Name in den Tippübersicht-Tabellen gekürzt. */
const OVERVIEW_NAME_MAX_LENGTH = 12;
const TRUNCATED_NAME_LENGTH = 9;

/**
 * Kürzt einen Namen für enge Tippübersicht-Tabellenspalten auf eine feste
 * Breite (9 Zeichen + "..."), damit lange Namen (bis zu DISPLAY_NAME_MAX_LENGTH)
 * die Zeilenhöhe nicht sprengen. Zeichenbasiert (nicht UTF-16-Code-Units),
 * damit Umlaute nicht mitten im Zeichen abgeschnitten werden.
 *
 * `trimEnd()` vor den Punkten: faellt der Schnitt genau hinter ein Leerzeichen
 * (z.B. "Wattwurm " -> 9 Zeichen), entstuende sonst "Wattwurm ..." mit einer
 * Luecke, an der die Zelle umbrechen kann. So wird daraus sauber "Wattwurm...".
 */
export function truncateForOverview(name: string): string {
  const chars = Array.from(name);
  if (chars.length <= OVERVIEW_NAME_MAX_LENGTH) return name;
  return `${chars.slice(0, TRUNCATED_NAME_LENGTH).join('').trimEnd()}...`;
}
